module.exports = __webpack_public_path__ + "static/img/cont44_07.b322d1d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont44_07.jpg
// module id = YvyI
// module chunks = 0